<template>
    <div class="shadow-card" :style="{
              'width': '790px',
    }" >
      <div :style="{ display: 'flex', alignItems: 'center',flexDirection:'column' }">
       
      <div :style="{ display: 'flex', alignItems: 'center','width':'100%' }">
        <a-avatar
          :style="{
            color: ' #ffffff !important',
            backgroundColor: review.reviewee.url ? 'transparent' : '#C997C5',
            fontSize: '12px',
            fontWeight: '900'
          }"
          :src="review.reviewee.url"
          :size="40"
          class="text-capitalize"
        >
          {{
            review.reviewee.role === 'doctor' || review.reviewee.role === 'hcp' ? review.reviewee.first_name  + review.reviewee.last_name :
            review.reviewee.display_name
              ? review.reviewee.display_name
              : ""
          }}
        </a-avatar>
        <div :style="{ flex: 1 }">
          <p
            class="text-name"
            :style="{ marginBottom: '0px', textTransform: 'capitalize' }"
          >
            {{ review.reviewee.role === 'doctor' || review.reviewee.role === 'hcp' ? review.reviewee.first_name + "" + review.reviewee.last_name : review.reviewee.display_name }}
          </p>
          <div :style="{ marginLeft: '16px' }" v-if="reviewType != null">
            <p
              class="text-day"
              :style="{
                color: getPrimaryColor(),
                marginLeft: 0,
                position: 'absolute',
                zIndex: 1,
                width: reviewType === 'MyCircles' ? '123px' : '90px',
                height: '22px ',
                textAlign: 'center'
              }"
            >
              {{
                reviewType === "InPerson"
                  ? "Practice Visit"
                  : reviewType === "Online"
                  ? "Online TeleMedicine"
                  : reviewType === "MyCircles"
                  ? "MyCircles"
                  : reviewType
              }}
            </p>
            <div
              :style="{
                background: getPrimaryColor(),
                opacity: 0.3,
                width: reviewType === 'MyCircles' ? '123px' : '90px',
                height: '22px ',
                borderRadius: '4px'
              }"
            />
          </div>
        </div>
        <div
          class="star-container"
          :style="{
            background: getPrimaryColor()
          }"
        >
          <font-awesome-icon
            size="2x"
            style="transform: scale(0.7); width: 24px; height: 24px; color: white"
            :icon="['fas', 'star']"
          />
        </div>
        <p class="review-text">{{ review.rating.toFixed(1) }}</p>
        <font-awesome-icon
          v-if="!expand"
          @click="expand = !expand"
          size="2x"
          style="transform: scale(0.7); width: 24px; height: 24px; margin-left: 20px; color: #94A3B8; cursor: pointer;"
          :icon="['fas', 'angle-down']"
        />
        <font-awesome-icon
          v-if="expand"
          @click="expand = !expand"
          size="2x"
          style="transform: scale(0.7); width: 24px; height: 24px; margin-left: 20px; color: #94A3B8; cursor: pointer;"
          :icon="['fas', 'angle-up']"
        />
      </div>
      <div v-if="expand" :style="{'width':'100%'}">
        <p
          class="review-description"
          :style="{
            marginBottom: description
              ? description.length > 150
                ? '0px'
                : '16px'
              : '0px'
          }"
          v-html="seeMore ? getLimitedDescription(description) : description"
        ></p>
        <div v-if="description">
          <p
            style="padding: 16px 0px"
            v-if="description.length > 150 && seeMore"
            @click="seeMore = !seeMore"
          >
            <span class="see-more">see more</span>
          </p>
          <!-- <p
            style="padding: 16px 0px"
            v-if="description.length > 150 && !seeMore"
            @click="seeMore = !seeMore"
          >
            <span class="see-more">see less</span>
          </p> -->
        </div>
        <div
          style="display: flex; row-gap: 16px; column-gap: 8px;flex-wrap: wrap; padding-bottom: 32px;"
        >
          <div
            class="rate-box"
            v-for="(item, index) in rating_list"
            v-if="rating_value_list[index]"
          >
            {{ item }}
            <i
              class="fa fa-star-o"
              aria-hidden="true"
              :style="{
                color: getPrimaryColor(),
                width: '24px'
              }"
            ></i>
            <span
              v-if="rating_value_list[index]"
              :style="{
                color: getPrimaryColor()
              }"
              v-html="getRating(rating_value_list[index])"
            ></span>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <p class="footer-text">
            Was this review helpful?<span>
              <i
                v-if="!reaction.like"
                class="fa fa-thumbs-o-up fa-lg"
                style="margin-left: 20px; cursor: pointer;"
                aria-hidden="true"
                @click="setReactions('like', review.id)"
              ></i>
              <i
                v-else
                class="fa fa-thumbs-up fa-lg"
                :style="{
                  marginLeft: '20px',
                  color: getPrimaryColor(),
                  cursor: 'pointer'
                }"
                aria-hidden="true"
                @click="deleteReaction(like_id, 'like', review.id, 'deleteLike')"
              ></i>
              <i
                v-if="!reaction.dislike"
                class="fa fa-thumbs-o-down fa-lg"
                style="margin-left: 20px; cursor: pointer;"
                aria-hidden="true"
                @click="setReactions('dislike', review.id)"
              ></i>
              <i
                v-else
                class="fa fa-thumbs-down fa-lg"
                :style="{
                  marginLeft: '20px',
                  color: getPrimaryColor(),
                  cursor: 'pointer'
                }"
                aria-hidden="true"
                @click="
                  deleteReaction(dislike_id, 'like', review.id, 'deleteDislike')
                "
              ></i>
            </span>
          </p>
          <p
            class="footer-text"
            style="cursor: pointer;"
            @click="setReactions('flag', review.id)"
          >
            <span>
              <i
                v-if="!reaction.flag"
                class="fa fa-flag-o fa-lg"
                style="margin-right: 10px;"
                aria-hidden="true"
              ></i>
              <i
                v-else
                class="fa fa-flag fa-lg"
                :style="{ marginRight: '10px', color: getPrimaryColor() }"
                aria-hidden="true"
              ></i> </span
            >Flag Review
          </p>
        </div>
      </div>
    </div>
    </div>
  </template>
  
  <script>
  import { library } from "@fortawesome/fontawesome-svg-core";
  import {
    faFilter,
    faStar,
    faFlag,
    faThumbsDown,
    faThumbsUp,
    faAngleDown,
    faAngleUp
  } from "@fortawesome/pro-solid-svg-icons";
  import { RepositoryFactory } from "../../../../repositories/RepositoryFactory";
  
  const PostRepository = RepositoryFactory.get("posts");
  
  library.add(
    faFilter,
    faFlag,
    faStar,
    faThumbsDown,
    faThumbsUp,
    faAngleDown,
    faAngleUp
  );
  
  export default {
    name: "ReviewCard",
  
    props: {
      reviewData: Object ,
      index : Number,
    },
  
    data() {
      return {
        review: null,
        image: null,
        name: null,
        title: null,
        reviewType: null,
        rating_list: [
          "Ease of Appointment",
          "Cost of consultation",
          "Ease of use of technology",
          "Knowledgeability",
          "Satisfaction",
          "Compassion",
          "Wait time",
          "Friendliness of Staff",
          "Attentiveness",
          "Quality Time",
          "Politeness",
          "Knowledge",
          "Length of Visit"
        ],
        rating_value_list: [],
        expand: false,
        time: "",
        description: null,
        seeMore: true,
        reaction: { flag: false, like: false, dislike: false },
        like_id: null,
        dislike_id: null,
        flag_id: null
      };
    },
  
    created() {
      if(this.index == 0) {
        this.expand = true ;
      }
      this.review = this.reviewData;
      this.reaction.flag = this.review.flag_reaction ? true : false;
      this.reaction.like = this.review.like_reaction ? true : false;
      this.reaction.dislike = this.review.dislike_reaction ? true : false;
      this.flag_id = this.review.flag_reaction
        ? this.review.flag_reaction[0].id
        : null;
      this.like_id = this.review.like_reaction
        ? this.review.like_reaction[0].id
        : null;
      this.dislike_id = this.review.dislike_reaction
        ? this.review.dislike_reaction[0].id
        : null;
      this.time = this.formatPostTime(this.review.created_at);
      if (this.review.reviewee_role === "doctor") {
        this.image = this.review.reviewee.url;
        this.name =
          this.review.reviewee.first_name + " " + this.review.reviewee.last_name;
        this.title = `, ${this.review.reviewee.title}`;
        this.reviewType = this.review.type;
      } else if (this.review.reviewee_role === "hospital_administrator") {
        this.image = this.review.reviewee.image;
        this.name = this.review.reviewee.hospital_name;
      } else if (this.review.reviewee_role === "clinic_administrator") {
        this.image = this.review.reviewee.image;
        this.name = this.review.reviewee.clinic_name;
      } else if (this.review.reviewee_role === "hcp") {
        this.image = this.review.reviewee.image;
        this.name = this.review.reviewee.full_name;
        this.reviewType = this.review.type;
      }
      this.description = this.review.description;
      this.rating_value_list.push(
        this.review.ease_of_appointment,
        this.review.cost_of_appointment,
        this.review.ease_of_use_of_technology,
        this.review.knowledge_ability,
        this.review.satisfaction,
        this.review.compassion,
        this.review.wait_time,
        this.review.friendliness,
        this.review.attentiveness,
        this.review.quality_time,
        this.review.politeness,
        this.review.knowledge,
        this.review.length_of_visit
      );
    },
    methods: {
      formatPostTime(value) {
        const d = new Date(value);
        const now = new Date();
        const seconds = Math.round(
          Math.abs((now.getTime() - d.getTime()) / 1000)
        );
        const minutes = Math.round(Math.abs(seconds / 60));
        const hours = Math.round(Math.abs(minutes / 60));
        const days = Math.round(Math.abs(hours / 24));
        const months = Math.round(Math.abs(days / 30.416));
        const years = Math.round(Math.abs(days / 365));
        if (Number.isNaN(seconds)) {
          return "";
        } else if (seconds <= 45) {
          return "a few seconds ago";
        } else if (seconds <= 90) {
          return "a minute ago";
        } else if (minutes <= 45) {
          return minutes + " minutes ago";
        } else if (minutes <= 90) {
          return "an hour ago";
        } else if (hours <= 22) {
          return hours + " hours ago";
        } else if (hours <= 36) {
          return "a day ago";
        } else if (days <= 25) {
          return days + " days ago";
        } else if (days <= 45) {
          return "a month ago";
        } else if (days <= 345) {
          return months + " months ago";
        } else if (days <= 545) {
          return "a year ago";
        } else {
          // (days > 545)
          return years + " years ago";
        }
      },
      getLimitedDescription(description) {
        const div = document.createElement("div");
        div.innerHTML = description;
        const text = div.textContent || div.innerText || "";
  
        return text.length > 150 ? text.substring(0, 150) + "..." : text;
      },
      getRating(rating) {
        return parseFloat(rating).toFixed(1);
      },
      reactReview(rType, revId) {
        const REACTION_TYPES = { flag: 5, like: 2, dislike: 11 };
        const payload = {
          reacted_on_type: 10,
          reacted_on_id: revId,
          user: this.authUser.user.id,
          user_role: this.authUser.user.role || "",
          reaction_type: REACTION_TYPES[rType]
        };
  
        PostRepository.saveReaction(this.currentCircle.id, payload)
          .then(res => {
            this.reaction[rType] = true;
            if (rType === "like") {
              this.like_id = res.data.data.id;
            } else if (rType === "dislike") {
              this.dislike_id = res.data.data.id;
            } else if (rType === "flag") {
              this.flag_id = res.data.data.id;
            }
            this.$notification.success({
              message: "Successful",
              description: `${
                rType === "like"
                  ? "Helpful"
                  : rType === "dislike"
                  ? "Unhelpful"
                  : "Flag"
              } has been saved`
            });
          })
          .catch(err => {
            this.$notification.error({
              message: "Error",
              description: `Cannot ${rType}`
            });
          });
      },
      deleteReaction(id, rType, revId, deleteType) {
        const user = JSON.parse(localStorage.getItem("user"));
        const headers = {
          Authorization: `Bearer ${user.user.token}`
        };
        this.$http
          .delete(`${process.env.BASE_API_URL}/reactions/?ids=${id.toString()}`, {
            headers
          })
          .then(res => {
            if (deleteType === "deleteLike") {
              this.reaction["like"] = false;
              this.$notification.success({
                message: "Successful",
                description: `Helpful has been unsaved`
              });
            } else if (deleteType === "deleteDislike") {
              this.reaction["dislike"] = false;
              this.$notification.success({
                message: "Successful",
                description: `Unhelpful has been unsaved`
              });
            } else if (deleteType === "flag") {
              this.reaction[deleteType] = false;
              this.$notification.success({
                message: "Successful",
                description: `Flag has been unsaved`
              });
            } else {
              this.reaction[deleteType] = false;
            }
            if (
              deleteType != "flag" &&
              deleteType != "deleteLike" &&
              deleteType != "deleteDislike"
            ) {
              this.reactReview(rType, revId);
            }
          })
          .catch(err => {
            this.$notification.error({
              message: "Error",
              description: `Cannot ${rType}`
            });
          });
      },
      setReactions(rType, revId) {
        if (rType === "dislike") {
          if (this.reaction.like === true) {
            this.deleteReaction(this.like_id, rType, revId, "like");
          } else {
            this.reactReview(rType, revId);
          }
        } else if (rType === "like") {
          if (this.reaction.dislike === true) {
            this.deleteReaction(this.dislike_id, rType, revId, "dislike");
          } else {
            this.reactReview(rType, revId);
          }
        } else if (rType === "flag") {
          if (this.reaction.flag === true) {
            this.deleteReaction(this.flag_id, rType, revId, "flag");
          } else {
            this.reactReview(rType, revId);
          }
        }
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .text-name {
    font-weight: 700;
    font-size: 16px;
    color: #0f1734;
    margin-left: 16px;
    margin-bottom: 4px;
    text-transform: capitalize;
  }
  
  .text-day {
    font-weight: 400;
    font-size: 12px;
    color: #94a3b8;
    margin-left: 16px;
    margin-bottom: 0px;
  }
  
  .text-reviewed {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #0f1734;
    text-transform: none;
  }
  
  .text-link {
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
  }
  
  .review-text {
    font-weight: 700;
    font-size: 16px;
    color: #0f1734;
    margin-left: 8px;
  }
  
  .star-container {
    width: 24px;
    height: 24px;
    border-radius: 2px;
  }
  
  .review-description {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #647490;
    padding-top: 16px;
  }
  
  .see-more {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #94a3b8;
    cursor: pointer;
  }
  
  .rate-box {
    font-weight: 700;
    font-size: 12px;
    color: #0f1734;
    background: #f1f5f9;
    border-radius: 8px;
    padding: 8px;
    text-align: center;
  }
  
  .footer-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #0f1734;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Users/Doctor/view/ReviewPhyCard.vue